import React from "react";
import AadhaarDigilocker from "../../../../Components/AadhaarDigilocker";


// Same DigiLocker flow as the customer app: the widget opens on this page and the Aadhaar
// data is fetched as soon as the associate completes it (see Components/AadhaarDigilocker).
// An associate's Aadhaar counts as done once its DigiLocker data is on the record.
const AadhaarStage = ({ associateDetails, onVerified }) => {

    const associateId = associateDetails?.associateId;
    return (
        <AadhaarDigilocker
            initialAadhaarNo={associateDetails?.kyc?.aadhaar?.aadhaarNo}
            status={associateDetails?.kyc?.aadhaar?.aadhaarDetails ? "verified" : undefined}
            linkUrl={`/admin/client/associate/kyc/aadhaar/${associateId}`}
            verifyUrl={`/admin/client/associate/kyc/aadhaar/verify/${associateId}`}
            
            onVerified={onVerified}
        />
    );
};

export default AadhaarStage;
